import { useMemo } from "react";

import Pagination from "@mui/material/Pagination";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const CustomTablePagination = ({
  paginationProps: {
    rowCount,
    rowsPerPage,
    changePage,
    changeRowsPerPage,
    options: { rowsPerPageOptions },
  },
}) => {
  /**
   * useTranslation
   */
  const { t } = useTranslation();

  const count = useMemo(() =>
    Math.ceil(rowCount > rowsPerPage ? rowCount / rowsPerPage : 1, [
      rowCount,
      rowsPerPage,
    ])
  );

  return (
    <div style={{ display: "block", overflowX: "auto" }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="flex-start"
        gap="1rem"
        padding="2.25rem"
      >
        <Grid
          item
          container
          xs={12}
          sm="auto"
          direction="column"
          justifyContent="center"
          alignItems={{ xs: "center", sm: "flex-start" }}
          gap="1rem"
        >
          <Stack direction="row" spacing={1}>
            {rowsPerPageOptions.map((opt, index) => {
              return (
                <Chip
                  key={index}
                  label={opt}
                  className={
                    rowsPerPage === opt
                      ? "pagination_chips pagination_chips--active"
                      : "pagination_chips"
                  }
                  onClick={() => changeRowsPerPage(opt)}
                />
              );
            })}
          </Stack>

          <span className="label__text-grey">
            {t("App.tables.pagination.resultsPerPage")}
          </span>
        </Grid>

        <Grid
          item
          xs={12}
          sm="auto"
          textAlign={{ xs: "center", sm: "initial" }}
        >
          <Pagination
            color="secondary"
            size="small"
            count={count}
            siblingCount={0}
            boundaryCount={1}
            showFirstButton
            showLastButton
            onChange={(page, value) => changePage(value - 1)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CustomTablePagination;
